import { clickTrackDetailPage } from './tracking';
import Marketplaces from '../../lib/singletons/marketplaces';
import deployEnv from 'environment-paypal';
//import { sendConfirmationEmail } from '../actions/myapps';

const PROD_HOSTNAME = 'https://www.paypal.com';
const STAGE_HOSTNAME = 'https://www.msmaster.qa.paypal.com';
const SB_HOSTNAME = 'https://www.sandbox.paypal.com';

const SELL_CATEGORY_INDEX = '6';

const triggerBack = props => {
  const { partner, history, dispatch, updateTab, updatePath } = props;
  clickTrackDetailPage(props, partner, 'detail_back');
  window.fpti.pgrp = 'main:merchanthub:partnerapps::main';
  // If action is push, user was client side routed and can be taken back where they came from (sell or discover)
  if (history.action.toLowerCase() === 'push') {
    history.goBack();

    if (window.historyStack) {
      dispatch(updatePath(window.historyStack.pop()));
    }
  } else {
    history.push('/sell');
    dispatch(updateTab(SELL_CATEGORY_INDEX));
  }
};

const triggerLink = (pos, props) => {
  const { partner } = props;
  const marketplaces = Marketplaces.instance();
  const marketplace = marketplaces[partner];

  clickTrackDetailPage(props, partner, `connect_${pos}`);
  window.location.href = marketplace.link;
};

const getLink = (partner, marketplaceConnectConfig = {}) => {
  const host = getHost();
  const { client_id, scope, redirect_uri } =
    marketplaceConnectConfig[partner] || {};
  return `${host}/connect/?flowEntry=static&response_type=code&client_id=${encodeURIComponent(
    client_id
  )}&scope=${encodeURIComponent(scope)}&redirect_uri=${encodeURIComponent(
    redirect_uri
  )}`;
};

const getHost = () =>
  typeof window === 'undefined' ? getHostServerSide() : getHostClientSide();

const getHostClientSide = () => {
  const { hostname, protocol } = window.location;
  return hostname.includes('localhost')
    ? STAGE_HOSTNAME
    : `${protocol}//${hostname}`;
};

const getHostServerSide = () => {
  if (deployEnv.isDev() || deployEnv.isStage()) {
    return STAGE_HOSTNAME;
  } else if (deployEnv.isSandbox()) {
    return SB_HOSTNAME;
  }
  return PROD_HOSTNAME;
};

export { triggerBack, triggerLink, getLink };
